<template>
  <div>
    <v-container v-if="value.title || value.paragraph">
      <TitleParagraphRow :value="value" />

      <v-row>
        <v-col>
          <v-divider style="opacity: 0.5" />
        </v-col>
      </v-row>
    </v-container>

    <template v-if="value.items && value.items.length">
      <v-sheet
        v-for="(item, i) in value.items"
        :key="item.id"
        :class="!(i % 2) ? 'bg-background' : 'bg-surface-light'"
        class="py-10"
      >
        <VerticalWhyItem :opposite="i % 2 ? true : false" :value="item" />
      </v-sheet>
    </template>
  </div>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
